// extracted by mini-css-extract-plugin
module.exports = {"itemColumnCarousel":"benefits-module--itemColumnCarousel--1KdlG","itemColumnCarousel__image":"benefits-module--itemColumnCarousel__image--1x1RP"};